import { render, staticRenderFns } from "./CityPhotos.vue?vue&type=template&id=1112b075&"
import script from "./CityPhotos.vue?vue&type=script&lang=js&"
export * from "./CityPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports